import type { SettingsState } from '../slices/settingsSlice'
import type { RootState } from '../store'

export const settingsLangSelector = (
  state: RootState
): SettingsState['lang'] | undefined => state.settings.lang
